import React from 'react';

/**
 * Simple anchor/link component that replaces aplanet-ui-kit's A.
 *
 * Props:
 *  - href      (string)   URL for the link
 *  - newWindow (boolean)  Open in new tab
 *  - onClick   (function) Click handler (used without href as a button-like link)
 *  - className (string)   CSS class names
 *  - children  (node)     Content
 */
const A = ({
  href,
  newWindow,
  onClick,
  className,
  children,
  ...rest
}) => {
  if (onClick && !href) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        className={className}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter') onClick(e); }}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      {...(newWindow ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...rest}
    >
      {children}
    </a>
  );
};

export default A;
